export const PRO_TAB_QUERY_PARAM_KEY = 'tab'
